// extracted by mini-css-extract-plugin
export default {"meetings__table--description":"styles_meetings__table--description__Zuu49","meetings__table--link":"styles_meetings__table--link__4Lt6v"};